module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_Model_Profile', {

		configure: function () {

			this.registerOptions('', {
				
				widgets: {
					profileApi: {
						widget: 'Api',
						method: 'Portal_Model.getData'
					},

					modelProfile: {
						widget: 'Widget',
						template: 'model_profile',
						manualRender: true,
						autoRender: false,
						embed: {
							widget: '@parent @parent',
							container: '.models-sitepage-wrapper'
						}
					},

					modelContentList: {
						widget: 'Catalog_List_Content',
						customLoad: true,
						embed: {
							widget: '@parent #modelProfile',
							container: '.list-wrapper'	
						}
						
					},

					subscribePopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.widget': 'Popup_Model_Subscription',
						//'!widgets.content.embed.container': '.ui-widget-content',
					},

					successPopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.template': 'popup_model_subscription_success'
					},

					errorPopup: {
						widget: 'Dialog',
						useUiPosition: true,
						'dialog.width': 370,
						'!widgets.content.template': 'popup_model_subscription_error'
					}
				},

				handleWom: {
					handleApiResponse: {
						widget: '#profileApi',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},
					modelProfileLoaded: {
						widget: '@this',
						event: 'modelProfileLoaded',
						callback: '_modelProfileLoaded'
					},
					profileChange: {
						widget: '@root #navi',
						event: 'modified_1',
						callback: '_handleNavi'
					}
				},

				handleDom: {
					toggleIntroductionText: {
						targetWidget: '#modelProfile',
						event: 'click',
						target: '.show-full .show-more',
						callback: 'toggleIntroductionText'
					},
					switchTab: {
						targetWidget: '#modelProfile',
						event: 'click',
						target: '.stats-table .header .item',
						callback: '_switchTab'
					},
					showSubscriptionPopup: {
						targetWidget: '#modelProfile',
						target: '.show-subscribe-popup',
						event: 'click',
						callback: 'showSubscriptionPopup'
					}
				}

			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.wom1('#profileApi');
			this.contentList = this.wom1('#modelContentList');
			this.modelProfile = this.wom1('#modelProfile');

			this.modelData = {};

			this.getProfileData(this.prepareId(fox.Navigator.get(1)));

			this.callParent('running', arguments);
		},

		activating: function (param) {
			this.getProfileData(param.id);

			this.callParent('activating', arguments);
		},

		_handleNavi: function (param, navi, e) {
			//console.log('_handleNavi', arguments);

			if (fox.isString(param) && !fox.isEmpty(param)) {
				this.getProfileData(param);
				this.contentList.reset();
				this.contentList.resetPager();
			}
		},

		getProfileData: function (id) {
			//console.log('getProfileData', id)
			this.contentList.eventsList._readyToEmbed = false;
			var id = this.prepareId(id);
			this.api.send({id: id});

			this.contentList.prepareSearchParams(id);
			//this.contentList.setTransitParameter('clientId', id);
			this.contentList.masonry('destroy');
			this.contentList.loadEvents();

			this.modelData['id'] = id;
		},

		_handleApiResponse: function (resp, w, e) {

			if (e == 'failure' || e == 'error') {
				console.error('something gone wrong', w.getAlias(), resp);

				return;
			}

			this.modelData['data'] = resp.answer.response;

			this.dispatchEvent('modelProfileLoaded')
		},

		_modelProfileLoaded: function () {
			//console.log('_modelProfileLoaded')
			this.contentList.eventsList._readyToEmbed = true;

			this.modelProfile.setTemplateOptions(this.modelData.data.success)
			this.modelProfile.render();



			this.wom1('#subscribePopup #content').setModelData(this.modelData);
			//this.contentList.setTransitParameter('name', fox.objectGet(this.modelData.success, 'stats.name'));
			//this.contentList.setTransitParameter('clientId', fox.Navigator.get(1));
			//this.contentList.loadEvents();
		},

		toggleIntroductionText: function () {
			fox.dom.addClass('full', this.modelProfile.dom1('.introduction'));
		},

		_switchTab: function (el) {
			this.switchTab($(el).attr('data-tab-alias'));
		},

		switchTab: function (alias) {
			var w = this.modelProfile;

			fox.each(w.dom('.stats-table .item'), function (el) {
				var el = $(el);
				var elAlias = el.attr('data-tab-alias')

				el.removeClass('active')

				if (alias == elAlias) {
					el.addClass('active');
				}
			}, this);
		},

		showSubscriptionPopup: function () {
			this.wom1('#subscribePopup').show();
		},

		prepareId: function (str) {
			var regExp = /\d+$/;

			return str.match(regExp)[0];
		}

	}, 'Controller');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/model/profile.js
// module id = 126
// module chunks = 0